"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryConstraints = void 0;
const firestore_1 = require("comodel/firestore");
const firestore_2 = require("firebase/firestore");
const getQueryConstraintForKey = ({ condition, key, }) => {
    if (condition === undefined) {
        return [];
    }
    else if (typeof condition === "object") {
        const queries = [];
        for (const [operator, value] of Object.entries(condition)) {
            const firestoreOperator = firestore_1.OperatorMap[operator];
            if (!firestoreOperator) {
                console.error("You cannot use this query in firestore", condition);
                continue;
            }
            queries.push((0, firestore_2.where)(key, firestoreOperator, value));
        }
        return queries;
    }
    else {
        return [(0, firestore_2.where)(key, "==", condition)];
    }
};
const getQueryConstraints = (params) => {
    const queries = [];
    const convertKey = (key) => params.idKey === key ? (0, firestore_2.documentId)() : key;
    if (params.filter) {
        for (const key of Object.keys(params.filter)) {
            queries.push(...getQueryConstraintForKey({
                key: convertKey(key),
                condition: params.filter[key],
            }));
        }
    }
    if (params.documentId) {
        queries.push(...getQueryConstraintForKey({
            key: (0, firestore_2.documentId)(),
            condition: params.documentId,
        }));
    }
    if (params.orderBy) {
        queries.push(...params.orderBy.map(([path, direction]) => (0, firestore_2.orderBy)(convertKey(path), direction)));
    }
    if (typeof params.limit === "number") {
        queries.push((0, firestore_2.limit)(params.limit));
    }
    if (typeof params.limitToLast === "number") {
        queries.push((0, firestore_2.limitToLast)(params.limitToLast));
    }
    return queries;
};
exports.getQueryConstraints = getQueryConstraints;
